import { Box, ListItem, Text, UnorderedList } from '@chakra-ui/react';

function PasswordInfo() {
  return (
    <Box bg="brand.lightGray2" p="10px" borderRadius="5px">
      <Text color="brand.darkPurple" textStyle="extraSmallSemiBold">
        Your password must contain at least
      </Text>
      <UnorderedList color="brand.mutedPurple" textStyle="extraSmallMedium" mt="10px" ml="18px">
        <ListItem>8 characters</ListItem>
        <ListItem>1 uppercase letter</ListItem>
        <ListItem>1 number (0-9)</ListItem>
        <ListItem>1 special character</ListItem>
      </UnorderedList>
    </Box>
  );
}

export default PasswordInfo;
